<template>
	<div>
		<div class="content" @click="showindex = -1">
			<!-- 项目状态菜单：已完成/待完成/未开始 -->
			<div class="msg" @click="showindex = -1">
				<div class="msg-main" v-for="(item, index) in menu" :key="index" @click="menus(item.id)">
					<div class="msg-menu">
						<img :src="item.img" class="msg-img" :class="{'msg-img1': menuid === item.id}" />
						<span v-if="menuid !== item.id" style="font-size: 15px;font-weight: 400;">{{item.name}}</span>
					</div>
				</div>

			</div>

			<div class="content-main">
				<Snoing :Smenuname="menuname" v-if="menuid === '0'" />
				<Sing :Smenuname="menuname" v-if="menuid === '1'" />
				<Sover :Smenuname="menuname" v-if="menuid === '2'">
				</Sover>

			</div>
		</div>
	</div>
</template>

<script>
	// 仅保留核心接口和组件：项目列表查询、未开始项目子组件、缓存工具
	import {
		ALLprj
	} from "../../utils/request.js";
	import Snoing from "./Snoing.vue";
	import Sing from "./Sing.vue";
	import Sover from "./Sover.vue";
	import {
		Getitem
	} from "../../utils/item.js";

	export default {
		data() {
			return {
				// -------------------------- 核心菜单数据 --------------------------
				/** 项目状态菜单：id对应状态（0未开始/1待完成/2已完成），name菜单名，img图标路径 */
				menu: [{
						id: '0',
						name: '未开始项目',
						img: require("../../assets/wks.png")
					},
					{
						id: '1',
						name: '进行中项目',
						img: require("../../assets/gzz.png")
					},
					{
						id: '2',
						name: '已完成项目',
						img: require("../../assets/ywc.png")
					},
				],
				/** 当前选中的菜单ID（默认未开始项目） */
				menuid: '0',
				/** 当前选中菜单的名称（传给子组件） */
				menuname: '',
				/** 点击空白处重置的索引（避免菜单展开冲突） */
				showindex: -1,

				// -------------------------- 核心项目数据 --------------------------
				/** 所有个人项目列表（接口返回） */
				prjlist: [],
				/** 按当前菜单筛选后的项目列表（传给子组件） */

				name: Getitem('name'),
				butfufei: null

			};
		},
		components: {
			Snoing,
			Sing,
			Sover

		},
		methods: {

			/**
			 * 菜单切换逻辑：更新选中菜单ID、筛选项目列表、设置菜单名称
			 * @param {string} id - 选中菜单的ID（0/1/2）
			 */
			async menus(id) {
				this.menuid = id;
				// // console.log('编号：', this.menuid);
				// await this.allprj()

				// this.showlist = this.prjlist.filter(res => res.finishFlag === this.menuid);

				this.menuname = this.menu.find(res => res.id === this.menuid).name;
			},


			// async allprj() {
			// 	const res = await ALLprj();
			// 	if (res.code === 200) {
			// 		this.prjlist = res.list;
			// 		// 解析项目中的资料文件（Files字段为JSON字符串，转成数组）
			// 		this.prjlist.forEach(r => {
			// 			r.information = r.information || [];
			// 			r.information.forEach(d => {
			// 				d.Files = JSON.parse(d.Files || '[]');
			// 			});
			// 		});
			// 		// console.log(this.prjlist);
			// 	} else {
			// 		this.$toast.error(res.msg || '获取项目列表失败');
			// 	}
			// },

			/**
			 * 初始化/刷新项目列表（子组件回调触发）
			 * @async - 先加载项目列表，再默认选中"未开始项目"菜单
			 */
			// async runsh() {
			// 	await this.allprj();
			// 	// await this.menus('0'); // 默认切换到未开始项目菜单
			// },
			async srunsh() {
				// await this.allprj();
				await this.menus('0'); // 默认切换到未开始项目菜单
			}
		},
		/** 组件创建时初始化项目列表 */
		created() {
			this.srunsh();
		},
		/** 监听登录状态变化：用户名更新时重新加载项目列表 */
		watch: {
			'$store.state.username'(newVal, oldVal) {
				if (newVal !== oldVal) {
					this.name = newVal;
					// 登录状态变化时重新加载项目列表
					// if (this.name) {
					// 	this.allprj();
					// }
				}
			}
		}
	};
</script>

<style lang="less" scoped>
	/* 仅保留核心样式：布局、菜单、内容区，删除无用样式（如右侧详情、表单样式） */
	.content {
		height: 92vh;
		width: 100vw;
		position: absolute;
		bottom: 0;
		left: 0;
		right: 0;
		top: 8vh;
		z-index: 10;
		display: flex;
		flex-direction: column;
		align-items: center;
		background-color: aliceblue;
	}

	/* 项目状态菜单样式 */
	.msg {
		width: 100vw;
		height: 15vh;
		display: flex;
		justify-content: center;
		align-items: center;
		padding-top: 20px;
		background-color: #fdfdfd;
		box-shadow: 0 5px 5px -1px rgba(0, 0, 0, 0.6);
		position: relative;



		.msg-main {
			.msg-menu {
				display: flex;
				flex-direction: column;
				align-items: center;
				margin: 0 40px;
				color: #18688d;
				font-size: 15px;
				transition: transform 0.3s ease;
				cursor: pointer;

				/* 菜单图标默认样式 */
				.msg-img {
					width: 110px;
					height: 80px;
					margin-bottom: 10px;
					filter: drop-shadow(1px 1px 1px rgba(0, 0, 0, 0.3));
				}

				/* 菜单选中样式 */
				.msg-img1 {
					width: 160px;
					height: 120px;
					margin-bottom: 10px;
					filter: drop-shadow(0px 0px 0px rgba(0, 0, 0, 0));
				}

				/* 菜单hover动画 */
				&:hover {
					animation: bounce 0.5s ease;
				}
			}
		}
	}

	/* 菜单hover弹跳动画 */
	@keyframes bounce {

		0%,
		100% {
			transform: translateY(0);
		}

		50% {
			transform: translateY(-10px);
		}
	}

	/* 内容主体样式：仅保留容器布局 */
	.content-main {
		height: 70vh;
		width: 100vw;
		margin-top: 15px;
		display: flex;
		justify-content: start;
		align-items: center;
	}
</style>